import productPage from '../../../services/productPage/productPage.js';
import pigeon from '../../../utilities/js/pigeon/pigeon.js';

const actions = {
  productUpdateFromHash(context, data) {
    context.dispatch('productChanged', data);
  },
  productChanged(context, data) {
    productPage()
      .handleGeneralRequest(`${data.url}`, data.formData, 'get', 'include')
      .then((updatedData) => context.commit('updateProduct', updatedData));
  },
  quantityChanged(context, data) {
    productPage()
      .quantityChanged(data)
      .then(updatedPrice => {
        context.commit('updatePrice', updatedPrice);
        context.commit('updateQuantity', data.quantity);
      })
      .catch(error => {
        pigeon.publish('globalAppError:show', {message: error.response.data});
        return error;
      });
  },
  updateProduct(context, updatedData) {
    context.commit('updateProduct', updatedData);
  },
  addToCart(context, data) {
    productPage()
      .handleGeneralRequest(data.url, data.formData, 'post', 'include')
      .then((res) => context.dispatch('updateCart', Object.assign(res, {
        boxIndex: data.boxIndex,
        itemId: data.itemId,
        isAddedToCart: true,
        temporary: data.temporary
      })))
  },
  addToCartWithPrint(context, data) {
    return productPage()
      .addToBasketWithPrintData(data.url, data.formData)
      .then((res) => context.dispatch('updateCart', Object.assign(res, {
        boxIndex: data.boxIndex,
        itemId: data.itemId,
        isAddedToCart: true
      })))
  },
  updateCart(context, updatedCartData) {
    context.commit('updateCartCount', updatedCartData, {root: true});
    context.commit('showMinicart', updatedCartData, {root: true});
  },
  imageGalleryClicked(context, data) {
    context.commit('initPhotoSwipe', data);
  },
  indexUpdate(context, index) {
    context.commit('indexUpdate', index);
  }
};

export default actions;
